import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function challenge() {
  return (
    <section className="challenge_par challenge_peanut p-100 text_white">
      <Container>
        <Row>
          <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>Challenges & Solutions</h2>
            <p>
              There’s no shortage of apps for dog owners on the internet; hence,
              the biggest challenge that we faced was to make our app different
              so that it stands out from the rest. After careful consideration
              and thorough research, we decided to create an app that focuses on
              community building.
            </p>
            <p>
              Since the app uses dog owners’ locations to connect them with dog
              parks and other dog owners in the area, we needed to upload a
              large number of zip codes for the app to function smoothly
              throughout the United States. We created the application with
              certain features and functions to assist the users and deliver
              long-term value. Our experts successfully built the solution as
              per the client’s instructions.
            </p>
            <p>
              Another challenge we faced was user engagement. Building a large
              and active user base can be a challenge, especially in the early
              stages of app development. This is why we used gamification, and
              other features that make the app more fun and interactive to help
              boost engagement. Dog owners can take pictures of their dogs and
              share them with fellow pet parents on the app, making it a great
              opportunity to connect.
            </p>
            <p>
              The Peanut Butter Park app provides the ultimate solution to make
              pet parenting a more fun and easier experience.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto offset-xl-2 offset-lg-2 offset-md-1"
          >
            <div className="challenge_img text-center">
              <StaticImage
                src="../../../images/case-studies/peanut/challenge_img.webp"
                alt="TekRevol"
                className=""
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={791}
                height={792}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default challenge;
